

























import {
  updateIgnoreIresAdminOrIresClientCheck,
  getIgnoreIresAdminOrIresClientCheck,
} from "@/data/repository/ClientRepository";
import { Vue, Component } from "vue-property-decorator";
import PickerDialogComponent from "../common/PickerDialog.vue";
import ClickableTextFieldComponent from "@/components/common/ClickableTextField.vue";
import { ToolbarContentModule } from "@/store/modules/ToolbarContent";

@Component({
  components: {
    "clickable-text-field": ClickableTextFieldComponent,
    picker: PickerDialogComponent,
  },
})
export default class IresConfigurationComponent extends Vue {
  isLoading = true;

  ignoreIresAdminOrIresClientCheck = false;

  optionsReversed = [false, true];

  get formatYesNoForSpecialRights() {
    return (value: boolean) => {
      return this.$t(`common.${value ? "no" : "yes"}`).toString();
    };
  }

  toggleIresCheck() {
    updateIgnoreIresAdminOrIresClientCheck(this.ignoreIresAdminOrIresClientCheck);
  }

  // "Ist aktiv?" moved to the Status card of the client in the IRES Admin Client (#2610067), and the
  // ERP-Simulator to its Test card (#2610070), where IRES Cloud records who changed them for any
  // client; both are server-only in the rules since.
  created() {
    this.ignoreIresAdminOrIresClientCheck = getIgnoreIresAdminOrIresClientCheck();
    this.isLoading = false;
  }

  mounted() {
    this.setToolbarTitle();
  }

  setToolbarTitle() {
    const baseTitle = this.$t("pages.settings").toString();
    const currentPageTitle = this.$t("settings.ires.iresConfiguration").toString();

    const toolbarTitle = baseTitle + " > " + currentPageTitle;

    ToolbarContentModule.setToolbarTitle(toolbarTitle);
  }
}
